app.ui.registerUi('customScroller', function(app) {
	var helpers = app.helpers.funcs;
	return {
		implementationExists: function() {
			return true;
		},
		onLoaded: function (data) {
			if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
				this.init();
			}
		},
		init: function($scope) {
			var $scrollElems = helpers.resolveScope('.nano, .chosen-results', $scope);
			if ((!this.implementationExists()) || (!$scrollElems.length)) return;
			$scrollElems.each(function(key, elem) {
				// Native fallback: keep existing markup/hooks and ensure container can scroll
				// without requiring the nanoScroller plugin.
				$(elem).css({
					overflowY: 'auto'
				});
			});
		}
	};
});

